(ns pfo.search.component
  (:require [reagent.core :as reagent :refer [atom]]
            [pfo.common.component :as common]
            [pfo.collection.component :as collection]
            [pfo.assignment.component :as assignment :refer [assignment-list]]
            [pfo.search.model :as model]
            [pfo.api :as api :refer [process-error]]
            [promesa.core :as p]
            [pfo.widget.paginator :refer [paginator]]
            [pfo.util :as util :refer [handler reset-from-event str->int set-location]]))

(def type-collection "collection")
(def type-task "task")
(def type-event "event")
(def type-document "document")
(def type-document-comment "document_comment")
(def type-task-comment "task_comment")
(def type-event-comment "event_comment")

(defn collection-item [hit fields]
  [:span
   (if (= "gr" (:type fields))
     "Group" "Collection") ": "
   [:a {:href (str "#/collection/details/" (:id fields))} (util/html-elem :span (or (get-in hit [:fragments :parent_trail_text]) (:name fields))) (when-let [notes (get-in hit [:fragments :notes 0])] [:p (util/html-elem :span notes)])]])

(defn task-item [hit fields]
  [:span (if (:compliance fields) "Compliance: " "Task: ")
   [:a {:href (str "#/task/details/" (:id fields) "/")}
    (when-let [group-name (or
                            (first (:group_name (:fragments hit)))
                            (not-empty (:group_name fields)))]
      [:<> (util/html-elem :span group-name) ": "])
    (if (:name (:fragments hit))
      (util/html-elem :span (first (:name (:fragments hit))))
      [:span (:name fields) (when-let [description (first (:description (:fragments hit)))][:<> ": " (util/html-elem :span description)])])]])

(defn event-item [hit fields]
  [:span "Event: "
   [:a {:href (str "#/event/details/id/" (:id fields) "/")}
    (if (:name (:fragments hit))
      (util/html-elem :span (first (:name (:fragments hit))))
      [:span (:name fields) ": " (util/html-elem :span (first (:description (:fragments hit))))])]])

(defn document-item [hit fields]
  [:span "Document: "
   [:a {:href (str "#/document/details/" (:id fields))}
    (if (:complex_name (:fragments hit))
      (util/html-elem :span (first (:complex_name (:fragments hit))))
      [:span (:complex_name fields) ": " (util/html-elem :span (first (:body (:fragments hit))))])]])

(defn conversation-subject [conversation]
  (if-let [subject (not-empty (:subject conversation))]
    subject
    (util/ellipsis (:plaintext_body (last (:comments conversation))) 10)))

(defn document-comment-item [hit fields]
  [:span "Comment: "
   [:a {:href (str "#/document/details/" (:document_id fields))}
    (if-let [conversation-subject (first (:conversation_subject (:fragments hit)))]
      (util/html-elem :span conversation-subject)
      (util/html-elem :span (first (:body (:fragments hit)))))]])

(defn task-comment-item [hit fields]
  [:span "Comment: "
   [:a {:href (str "#/task/details/" (:task_id fields) "/")}
    (if-let [conversation-subject (first (:conversation_subject (:fragments hit)))]
      (util/html-elem :span conversation-subject)
      (util/html-elem :span (first (:body (:fragments hit)))))]])

(defn event-comment-item [hit fields]
  [:span "Comment: "
   [:a {:href (str "#/event/details/id/" (:task_id fields) "/")}
    (if-let [conversation-subject (first (:conversation_subject (:fragments hit)))]
      (util/html-elem :span conversation-subject)
      (util/html-elem :span (first (:body (:fragments hit)))))]])

(def document-type-components
  {type-collection collection-item
   type-task task-item
   type-event event-item
   type-document document-item
   type-document-comment document-comment-item
   type-task-comment task-comment-item
   type-event-comment event-comment-item
   })

(defn class-for-hit [hit]
  (let [fields (:fields hit)]
    (if (and (= "task" (:document_type fields)) (:compliance fields))
      "compliance"
      (:document_type fields))))

(defn search-results [query results]
  (let [current-page (atom 1)
        results (atom results)
        load-results (fn [page]
                       (reset! current-page page)
                       (->> (model/search query page)
                            (p/map (fn [search-response]
                                     (reset! results search-response)))
                            (process-error)))]
    (fn []
      [common/header-tab-wrapper
       [:span [:img.tab-header {:src "/static/img/icons/document.svg"}] "Search results: " query]
       (if (seq @results)
         [:table.search.t-table-redesign
          [:thead
           [:tr
            [:th.icon " "]
            [:th.item "Item"]
            [:th "Collection"]]]
          [:tbody
           (doall
             (for [{fields :fields
                    id :id
                    :as hit} (:results @results)]
               [:tr {:key id}
                [:td.icon {:class (class-for-hit hit)}]
                [:td.item [(document-type-components (:document_type fields)) hit fields]]
                [:td
                 [assignment-list (mapv (fn [collections] {:collection_id (:id (last collections))
                                                           :main true
                                                           :collection (assoc (last collections) :ancestors collections)})
                                        (:parent_trails fields))]]]))]]
         [:div.o-media.u-shadow--bottom "No matching items found."])])))

(defn search-field []
  (let [query (atom "")]
    (fn []
      [:div.search
       [:form {:on-submit (util/handler
                            (fn []
                              (collection/close-collection-nav nil)
                              (util/set-location (str "#/search?query=" (js/encodeURIComponent @query)))
                              (reset! query "")))}
         [:img.search-icon
          {:src
           "/static/img/icons/search.png",
           :alt "Search"}]
         [:input {:type "search" :placeholder "Search database"
                  :on-change (util/reset-from-event query)
                  :value @query}]] ])))
